define([
    "./skylark",
    "./router",
    "./spa",
    "./langx"
], function(skylark) {
    return skylark;
})
